import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { configConsumer, ITranslationsCollection, translate } from '@estee/elc-service';
import { buttonLabels } from '../../utils/ProductCTALabels';
import { IAddToCollectionButton, IAddToCollectionConfig } from '../../interfaces/IProductCTA';
import { ADD_TO_COLLECTION_BUTTON } from '../../constants/DataTestIdAttributes';
import { StyledAddToBagButton } from './ProductCTAStyles';
import { InventoryStatus } from '../../constants/InventoryStatuses';

@configConsumer(['translationsOverwrites', 'addToCollectionDataTestId', 'disabled'])
@translate([
    'addToCollectionButtonLabel',
    'addToBagButtonLabel',
    'comingSoonButtonLabel',
    'outOfStockButtonLabel',
    'preOrder',
    'soldOutButtonLabel'
])
@observer
export class AddToCollectionButton extends React.Component<IAddToCollectionButton> {
    @observable private buttonLabel = '';

    @action
    private onAddToCollectionClick = () => {
        const { onAddToCollectionClick } = this.props;
        onAddToCollectionClick();
    };

    @action
    private setButtonLabel = (label: string) => {
        this.buttonLabel = label;
    };

    public render() {
        const { disabled, addToCollectionDataTestId, translationsOverwrites } = this.props
            .config as IAddToCollectionConfig;
        const { addingToBag, selectedSku, isOnCollection } = this.props;
        const isDisabled = disabled || !selectedSku.isShoppable || addingToBag;
        const translations = this.props.translations as ITranslationsCollection;
        const { addToCollectionButtonLabel, addedToCartLabel } = translations;

        const addToCollectionButtonClassNames = classnames(
            'elc-add-to-collection-button',
            'js-add-to-collection-button',
            {
                'elc-add-to-collection-button-disabled': isDisabled,
                'js-add-to-collection-button-disabled': isDisabled
            }
        );

        const customCtaLabel = translationsOverwrites && translationsOverwrites.ctaButtonLabel;
        const activeButtonLabel = customCtaLabel || addToCollectionButtonLabel;
        const addToCollectionButtonLabels = buttonLabels(
            translationsOverwrites ? translations && translationsOverwrites : translations,
            activeButtonLabel,
            activeButtonLabel
        );
        this.setButtonLabel(
            addingToBag
                ? addedToCartLabel
                : addToCollectionButtonLabels[
                      isOnCollection ? InventoryStatus.OnBag : selectedSku.inventoryStatus
                  ] || this.buttonLabel
        );

        return (
            <StyledAddToBagButton
                aria-label={this.buttonLabel}
                className={addToCollectionButtonClassNames}
                data-test-id={
                    addToCollectionDataTestId ? addToCollectionDataTestId : ADD_TO_COLLECTION_BUTTON
                }
                disabled={isDisabled}
                onClick={this.onAddToCollectionClick}
                title={this.buttonLabel}
            >
                {this.buttonLabel}
            </StyledAddToBagButton>
        );
    }
}
